import React, { useState, useMemo } from 'react';
import { groupCapabilities } from '../utils/helpers';
import { Badge } from 'react-bootstrap';


const RoleCapabilitiesTree = ({ capabilities }) => {

  const [openModules, setOpenModules] = useState({});
  const [openRTs, setOpenRTs] = useState({});

  const grouped = useMemo(
    () => groupCapabilities(capabilities),
    [capabilities]
  );

  const toggleModule = (mod) =>
    setOpenModules(p => ({ ...p, [mod]: !p[mod] }));

  const toggleRT = (key) =>
    setOpenRTs(p => ({ ...p, [key]: !p[key] }));

  return (
    <div className="module-groups-list">
      {Object.keys(grouped).sort().map(mod => {

        const rts = grouped[mod];
        const modOpen = !!openModules[mod];

        return (
          <div key={mod} className="module-group">

            {/* MODULE */}
            <div
              className="module-group-header"
              onClick={() => toggleModule(mod)}
            >
              <span className="module-header-name">{mod}</span>
            </div>

            {modOpen && (
              <div className="module-group-body">

                {Object.entries(rts).map(([rt, caps]) => {

                  const rtKey = `${mod}_${rt}`;
                  const rtOpen = !!openRTs[rtKey];

                  return (
                    <div key={rt} className="role-modal-rt-group">

                      {/* RESOURCE TYPE */}
                      <div
                        className="role-modal-rt-header"
                        onClick={() => toggleRT(rtKey)}
                      >
                        <span className="rt-header-name">{rt}</span>
                        <Badge>{caps.length}</Badge>
                      </div>

                      {/* CAPABILITIES */}
                      {rtOpen && (
                        <div className="caps-assign-list">
                          {caps.map(cap => (
                            <div key={cap.id} className="cap-assign-row">
                              <strong>{cap.name}</strong>
                            </div>
                          ))}
                        </div>
                      )}

                    </div>
                  );
                })}

              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RoleCapabilitiesTree;